// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\n * Action css File\n*/\n\n.Action {\n    /* propertys here */\n}", "",{"version":3,"sources":["webpack://src/Components/Redux-Config/Action/Action.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;IACI,mBAAmB;AACvB","sourcesContent":["/*\n * Action css File\n*/\n\n.Action {\n    /* propertys here */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
